import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { pathMatchesRoute } from "@faire/web--source/common/routes/RouteMatcher";
import { isPrerender } from "@faire/web--source/common/user-agent/isPrerender";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick } from "@faire/web-api--source/events/loggedOutRetailers/click/loggedOutHomeRedesignCta";
import { trackLoggedOutRetailersLoggedOutHomeRedesignView } from "@faire/web-api--source/events/loggedOutRetailers/view/loggedOutHomeRedesign";
import { BATCH_5_HOMEPAGE_FIRST_SECTION_COPY_TEST_102124 } from "@faire/web-api--source/indigofair/settings/BATCH_5_HOMEPAGE_FIRST_SECTION_COPY_TEST_102124";
import { IFourVariantXP } from "@faire/web-api--source/indigofair/settings/IFourVariantXP";
import { route as brandRoute } from "@faire/web-api--source/routes/brand/brandToken";
import classNames from "classnames";
import React from "react";
import { useLocation } from "react-router-dom";
import { SlideIn } from "@faire/retailer-visitor-shared/components/SlideIn";
import { setTimeoutIfPossible } from "@faire/retailer-visitor-shared/lib/async-functions/setTimeoutIfPossible";
import { handleKeyDown } from "@faire/retailer-visitor-shared/lib/handleKeyDown";
import { useEffectAssignWhen } from "@faire/retailer/settings/useEffectAssignWhen";
import { useSettingHomePageFirstSectionCopyTestB5 } from "@faire/retailer/settings/useSettingHomePageFirstSectionCopyTestB5";
import { useSettingLoggedOutHomepageRedesignV2 } from "@faire/retailer/settings/useSettingLoggedOutHomepageRedesignV2";
import * as animationStyles from "@faire/retailer/views/home/logged-out-homepage/__internal__/components/__internal__/Animation/animation.css";
import { useAnimatedScroll } from "@faire/retailer/views/home/logged-out-homepage/__internal__/components/__internal__/Animation/useAnimatedScroll";
import { invisible } from "@faire/retailer/views/home/logged-out-homepage/__internal__/components/__internal__/Prerender/style.css";
import * as tabStyles from "@faire/retailer/views/home/logged-out-homepage/__internal__/components/__internal__/Tabs/tabs.css";
import { CategoryBestBrandsWithCTA } from "@faire/retailer/views/home/logged-out-homepage/__internal__/components/CategoryBestBrandsBanner/__internal__/CategoryBestBrandsWithCTA";
import * as componentStyles from "@faire/retailer/views/home/logged-out-homepage/__internal__/components/CategoryBestBrandsBanner/styles.css";
import { useCategoryBrandsBannerQuery } from "@faire/retailer/views/home/logged-out-homepage/__internal__/DataFetching/useCategoryBrandsBannerQuery";
export var CategoryBestBrandsBanner = function(param) {
    var loadTimingRef = param.loadTimingRef;
    var _useCategoryBrandsBannerQuery = useCategoryBrandsBannerQuery(), categoryBestBrands = _useCategoryBrandsBannerQuery.categoryBestBrands, isFetching = _useCategoryBrandsBannerQuery.isFetching;
    var location = useLocation();
    var isBrandPage = pathMatchesRoute(location, brandRoute);
    useEffectAssignWhen(BATCH_5_HOMEPAGE_FIRST_SECTION_COPY_TEST_102124, !isBrandPage);
    var _categoryBestBrands_length;
    var _useAnimatedScroll = useAnimatedScroll((_categoryBestBrands_length = categoryBestBrands === null || categoryBestBrands === void 0 ? void 0 : categoryBestBrands.length) !== null && _categoryBestBrands_length !== void 0 ? _categoryBestBrands_length : 0, 5000), resumeScroll = _useAnimatedScroll.resumeScroll, pauseScroll = _useAnimatedScroll.pauseScroll, isVisible = _useAnimatedScroll.isVisible, currentIndex = _useAnimatedScroll.currentIndex, setCurrentIndex = _useAnimatedScroll.setCurrentIndex;
    var selectedCategory = categoryBestBrands === null || categoryBestBrands === void 0 ? void 0 : categoryBestBrands[currentIndex];
    var handleClickTab = function(index, categoryName) {
        trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick("category_best_brands_banner-tab", categoryName, "".concat(homepageRedesignVariant));
        pauseScroll();
        setCurrentIndex(index);
        setTimeoutIfPossible(function() {
            resumeScroll();
        }, 12000);
    };
    var homepageRedesignVariant = useSettingLoggedOutHomepageRedesignV2();
    var tabRef = useDoActionWhenVisible(function() {
        return trackLoggedOutRetailersLoggedOutHomeRedesignView("category_best_brands_banner-tab", "".concat(homepageRedesignVariant));
    });
    if (isFetching) {
        return /*#__PURE__*/ _jsx("div", {
            style: {
                height: "700px"
            }
        });
    }
    if (!(categoryBestBrands === null || categoryBestBrands === void 0 ? void 0 : categoryBestBrands.length) || !selectedCategory) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Column, {
        className: componentStyles.container,
        ref: loadTimingRef,
        children: /*#__PURE__*/ _jsxs(SlideIn, {
            bottomThreshold: 100,
            offset: getSpacing("5x"),
            children: [
                /*#__PURE__*/ _jsxs(Column, {
                    className: classNames(componentStyles.headerAndTabs, animationStyles.animatedContainerParent),
                    children: [
                        /*#__PURE__*/ _jsx(CategoryBestBrandsHeader, {
                            isBrandPage: isBrandPage
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            height: "2x"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: tabStyles.tabBar,
                            ref: tabRef,
                            children: categoryBestBrands.map(function(category, index) {
                                return /*#__PURE__*/ _jsx("div", {
                                    onClick: function() {
                                        var _category_category_path_identifier;
                                        return handleClickTab(index, (_category_category_path_identifier = category.category_path_identifier) !== null && _category_category_path_identifier !== void 0 ? _category_category_path_identifier : "");
                                    },
                                    onKeyDown: handleKeyDown(function() {
                                        var _category_category_path_identifier;
                                        return handleClickTab(index, (_category_category_path_identifier = category.category_path_identifier) !== null && _category_category_path_identifier !== void 0 ? _category_category_path_identifier : "");
                                    }),
                                    children: /*#__PURE__*/ _jsx(Typography, {
                                        tabIndex: 0,
                                        "data-is-selected": index === currentIndex,
                                        className: classNames(tabStyles.tab),
                                        children: category.category_name
                                    })
                                }, index);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    style: {
                        overflow: "hidden",
                        width: "100%"
                    },
                    "data-is-visible": isVisible,
                    className: animationStyles.animatedContainer,
                    children: isPrerender() ? /*#__PURE__*/ _jsx(PrerenderCategories, {
                        categoryBestBrands: categoryBestBrands
                    }) : /*#__PURE__*/ _jsx(CategoryBestBrandsWithCTA, {
                        selectedCategory: selectedCategory,
                        pauseScroll: pauseScroll,
                        resumeScroll: resumeScroll
                    })
                })
            ]
        })
    });
};
var PrerenderCategories = function(param) {
    var categoryBestBrands = param.categoryBestBrands;
    return(// we want to have all categories in the DOM for prerendering
    /*#__PURE__*/ _jsx(_Fragment, {
        children: categoryBestBrands.map(function(category, index) {
            return /*#__PURE__*/ _jsx(CategoryBestBrandsWithCTA, {
                selectedCategory: category,
                className: index ? invisible : ""
            }, index);
        })
    }));
};
var CategoryBestBrandsHeader = function(param) {
    var isBrandPage = param.isBrandPage;
    var homepageRedesignVariant = useSettingLoggedOutHomepageRedesignV2();
    var headerRef = useDoActionWhenVisible(function() {
        return trackLoggedOutRetailersLoggedOutHomeRedesignView("category_best_brands_banner-header", "".concat(homepageRedesignVariant));
    });
    var settingHomePageFirstSectionCopyTestB5 = useSettingHomePageFirstSectionCopyTestB5();
    var newTitleVariantsOnHomepageOnly = isBrandPage ? IFourVariantXP.Bucket.CONTROL : settingHomePageFirstSectionCopyTestB5;
    var isXLargeAndAbove = useViewport().isXLargeAndAbove;
    switch(newTitleVariantsOnHomepageOnly){
        case IFourVariantXP.Bucket.VARIANT_2:
            return /*#__PURE__*/ _jsx(Typography, {
                variant: {
                    mobileAndAbove: "displaySSerifRegular",
                    desktopAndAbove: "displayMSerifRegular"
                },
                ref: headerRef,
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "a6Pfng",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Your one-stop shop for wholesale"
                        }
                    ]
                })
            });
        case IFourVariantXP.Bucket.VARIANT_3:
            if (isXLargeAndAbove) {
                return /*#__PURE__*/ _jsx(Typography, {
                    variant: {
                        mobileAndAbove: "displaySSerifRegular",
                        desktopAndAbove: "displayMSerifRegular"
                    },
                    ref: headerRef,
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "iu1FUl",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Buy from any category, all in one place"
                            }
                        ]
                    })
                });
            }
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: {
                            mobileAndAbove: "displaySSerifRegular",
                            desktopAndAbove: "displayMSerifRegular"
                        },
                        ref: headerRef,
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "czyLNq",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Buy from any category,"
                                }
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: {
                            mobileAndAbove: "displaySSerifRegular",
                            desktopAndAbove: "displayMSerifRegular"
                        },
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "G9+A+p",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "all in one place"
                                }
                            ]
                        })
                    })
                ]
            });
        case IFourVariantXP.Bucket.VARIANT_4:
            return /*#__PURE__*/ _jsx(Typography, {
                variant: {
                    mobileAndAbove: "displaySSerifRegular",
                    desktopAndAbove: "displayMSerifRegular"
                },
                ref: headerRef,
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "Ej9pbg",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Stock your shelves with proven bestsellers"
                        }
                    ]
                })
            });
        case IFourVariantXP.Bucket.CONTROL:
        default:
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: {
                            mobileAndAbove: "displaySSerifRegular",
                            desktopAndAbove: "displayMSerifRegular"
                        },
                        ref: headerRef,
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "YOkc9S",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "The best brands for every shelf\u2014"
                                }
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: {
                            mobileAndAbove: "displaySSerifRegular",
                            desktopAndAbove: "displayMSerifRegular"
                        },
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "v9JNmC",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "find them on Faire"
                                }
                            ]
                        })
                    })
                ]
            });
    }
};
